import clsx from 'clsx';
import styles from './otp-input.module.scss';
import { InputRedesigned } from '@/ui-kit';
import { ChangeEventHandler } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

interface Props {
    error: string | null
    register: UseFormRegisterReturn
    onOtpInput: ChangeEventHandler<HTMLInputElement>
}

export const OtpInput: React.FC<Props> = ({
    error,
    register,
    onOtpInput,
}) => {
    const INPUT_MAX_LEN = 1
    return (
        <InputRedesigned
            inputMode="numeric"
            maxLength={INPUT_MAX_LEN}
            className={clsx(styles.wrapper, error && styles.error)}
            { ...register }
            onChange={e => {
                register.onChange(e)
                onOtpInput(e)
            }} />
    )
}
